module.exports = __webpack_public_path__ + "img/photo_2022-10-26_22-16-55.ef508972.jpg";